import { Button, Dialog, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ShareDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    width: '90%',
    maxWidth: 600,
  },
});

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
}));

export const TitleRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
});

export const CloseIcon = styled(IconButton)({
  position: 'absolute',
  left: 0,
  top: 0,
});

export const Subtitle = styled(Typography)({
  textAlign: 'center',
  width: '100%',
  fontWeight: 'bold',
  marginTop: 10,
});

export const LoadingContainer = styled('div')({
  padding: '200px 0',
});

export const LoadingText = styled('div')(({ theme }) => ({
  textAlign: 'center',
  fontSize: 18,
  lineHeight: 1.5,
  fontWeight: 'bold',
  margin: `${theme.spacing(2)} 0`,
}));


export const InputContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

export const TextFieldContainer = styled('div')({
  position: 'relative',
});

export const TextFieldButtons = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  marginTop: theme.spacing(4),
}));

export const ShareButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: 200,
}));

export const SelectWrap = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: 200,
}));

export const CloseBtn = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
  width: 200,
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export const IconLarge = styled('div')({
  fontSize: '6rem',
});
